import React from 'react';
import { useNavigate } from 'react-router-dom';
import { nanoid } from 'nanoid';
import TransmitWebSDKEnterpriseAuth from 'syf-transmit-cal/dist/TransmitWebSDKEnterpriseAuth';
import {
  AuthRedirectParams,
  TransmitAuthParams,
  TransmitUserParams,
} from '../../interfaces/CustomerVerification.interface';
import calTransmitConfig from '../../transmit/config.json';
import transmitBranding from '../../transmit/transmitBranding.json';
import { VITE_NODE_ENV } from '../../utils/constants/envConstants';
import { CONTROL_CENTER_IMAGE_PATH } from '../../utils/constants/controlCenterConstants';
import { getDeviceFingerPrint } from '../../utils/helpers';

export const TRANSMIT_CONSTANTS = {
  defaultFirstName: 'notapplicable',
  defaultLastName: 'notapplicable',
  defaultZipCode: '00000',
  defaultChannel: 'cal-swallet-web',
  defaultClient: 'generic',
  defaultLanguage: 'EN',
  defaultClientLogoFullUrl: `${CONTROL_CENTER_IMAGE_PATH}/syf-logo.svg`,
};

export const Transmit = ({ handleAuth, userParams }: any) => {
  const navigate = useNavigate();
  try {
    const calTransmitConfigObject = JSON.stringify(calTransmitConfig);
    return (
      <TransmitWebSDKEnterpriseAuth
        config={calTransmitConfigObject}
        params={userParams}
        handleAuthResponse={handleAuth}
      />
    );
  } catch (error) {
    navigate(`/system-down`);
    return null;
  }
};

export const getAuthParams = ({
  lastFourSocial,
  phoneNumber,
  sessionId,
  clientId,
}: TransmitUserParams): TransmitAuthParams => {
  const deviceFingerprint = getDeviceFingerPrint();
  const transmitTransactionId = nanoid(14);

  return {
    header: {
      client_id: clientId,
      channel: TRANSMIT_CONSTANTS.defaultChannel,
      trans_id: transmitTransactionId,
    },
    first_name: TRANSMIT_CONSTANTS.defaultFirstName, // default for ANI lookup
    last_name: TRANSMIT_CONSTANTS.defaultLastName, // default for ANI lookup
    zip_code: TRANSMIT_CONSTANTS.defaultZipCode, // default for ANI lookup
    last_4_ssn: lastFourSocial,
    session_id: sessionId,
    phone_number: phoneNumber,
    user_id: phoneNumber,
    device_fingerprint: deviceFingerprint,
    language_code: TRANSMIT_CONSTANTS.defaultLanguage,
    app_env: VITE_NODE_ENV,
    branding: {
      ...transmitBranding,
      client_logo: TRANSMIT_CONSTANTS.defaultClientLogoFullUrl,
    },
  };
};

export const handleAuthRedirects = ({
  transmitResponseCode,
  transmitToken,
  dispatch,
  setTransmitToken,
  setShowEntryError,
  navigate,
}: AuthRedirectParams) => {
  switch (transmitResponseCode) {
    case '0000':
      dispatch(setTransmitToken(transmitToken));
      setShowEntryError(false);
      navigate('/dashboard');
      break;

    case '0002':
      setShowEntryError(true);
      navigate('/account-not-found');
      break;

    case '0003':
      setShowEntryError(false);
      navigate('/not-verified');
      break;

    case '0001':
    case '0004':
    case '5002':
    case '5003':
      dispatch(setTransmitToken(transmitToken));
      setShowEntryError(false);
      navigate('/system-down');
      break;

    case '0005':
    case '0006':
      setShowEntryError(false);
      navigate('/thank-you');
      break;

    case '5011':
      setShowEntryError(true);
      break;

    default:
      setShowEntryError(true);
      break;
  }
};
